import React, { createContext, useContext } from 'react';
import * as THREE from 'three';

interface ModelBoundsContextType {
  center?: THREE.Vector3;
  size?: THREE.Vector3;
  bottom?: number;
}

export const ModelBoundsContext = createContext<ModelBoundsContextType>({});

export const useModelBounds = () => {
  const context = useContext(ModelBoundsContext);
  return context;
}; 